<template>
  <div>
    <ts-page-title
      :title="$t('branchProfile.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('branchProfile.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="tw-whitespace-nowrap">{{ record.prefix_code }}</td>
            <td class="tw-whitespace-nowrap">{{ record.branch_name_kh }}</td>
            <td class="tw-whitespace-nowrap">{{ record.branch_name_en }}</td>
            <td class="tw-whitespace-nowrap">{{ record.phone }}</td>
            <td class="tw-whitespace-nowrap">{{ record.branch_address }}</td>
            <td class="tw-whitespace-nowrap">{{ record.branch_website }}</td>
            <td class="tw-whitespace-nowrap">{{ record.facebook_page }}</td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>

    <!-- form-action -->
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('branchProfile.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FromAction from "./form";

export default {
  name: "branchIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("corporate/branchProfile", ["resources", "pagination"]),
    columns() {
      return [
        {
          name: this.$t("branchProfile.prefix"),
          style: "width: 5%;white-space: nowrap;",
        },
        {
          name: this.$t("branchProfile.nameKh"),
          style: "width: 15%;white-space: nowrap;",
        },
        {
          name: this.$t("branchProfile.nameEn"),
          style: "width: 15%;white-space: nowrap;",
        },
        {
          name: this.$t("branchProfile.phone"),
          style: "width: 10%;white-space: nowrap;",
        },
        {
          name: this.$t("branchProfile.address"),
          style: "width: 25%;white-space: nowrap;",
        },
        {
          name: this.$t("branchProfile.website"),
          style: "width: 15%;white-space: nowrap;",
        },
        {
          name: this.$t("branchProfile.facebookPage"),
          style: "width: 10%;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 5%;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("corporate/branchProfile/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit("corporate/branchProfile/SET_EDIT_DATA", record);
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit("corporate/branchProfile/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("corporate/branchProfile/destroy", record.branch_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("corporate/branchProfile/RESET_STATE");
    next();
  },
};
</script>
